/* Dependencies */
import React, { Fragment } from 'react';
import { Spinner } from 'lego-dist';

/* Styled Components */
import { WidgetContainer, Header, WidgetLinkItem, WidgetLink } from '../styles';
import AppcuesService from '../../../services/AppcuesService';

interface IWidget {
  tours: any;
  onTourClicked?: () => void
}

interface ITourLink {
  uuid?: string;
  name?: string;
}

const appcuesService = AppcuesService.getInstance();

const Widget: React.FC<IWidget> = ({ tours, onTourClicked = () => {} }) => {
  const handleTourClick = (tourId: string = '') => {
    appcuesService.getAppcues().show(tourId);
    onTourClicked();
  };
  return (
    <WidgetContainer>
      {tours !== undefined ? (
        Object.entries(tours).map(([tourCategory, tourLinks]: any, index: number) => (
          <Fragment key={index}>
            <Header>{tourCategory}</Header>
            <WidgetLinkItem>
              {tourLinks.map((tourLink: ITourLink) => (
                <WidgetLink key={tourLink?.uuid} onClick={() => handleTourClick(tourLink?.uuid)}>
                  {tourLink?.name}
                </WidgetLink>
              ))}
            </WidgetLinkItem>
          </Fragment>
        ))
      ) : (
        <Spinner loading name="threedots" position="absolute" />
      )}
    </WidgetContainer>
  );
};

export default Widget;
